module.exports = __webpack_public_path__ + "assets/img/check.a385934b.svg";